import React from "react"
import Card from "../../../../containers/Card/Card"

import BusinessVerticalsField from "../../../BusinessVerticalsField/BusinessVerticalsField"
import ProhibitedBusinessVerticalsSubtitle from "../ProhibitedBusinessVerticalsSubtitle"
import ProhibitedBusinessVerticalsIcon from "../ProhibitedBusinessVerticalsIcon"
import {FormikProps} from "formik"
import {isEqualWith} from "lodash"
import TitleWithBadge from "../../../TitleWithBadge/TitleWithBadge"
import {isEqualAsSet} from "../../../../utilities/set"

interface ProhibitedBusinessVerticalsProps {
	name: string
	value: string[]
	defaultValue?: string[]
	setFieldValue: FormikProps<unknown>["setFieldValue"]
	setFieldTouched: FormikProps<unknown>["setFieldTouched"]
}

export default function ProhibitedBusinessVerticalsEditMode({
	name,
	value,
	defaultValue,
	setFieldValue,
	setFieldTouched,
}: ProhibitedBusinessVerticalsProps) {
	return (
		<div className="risk-settings-card">
			<Card
				title={
					<TitleWithBadge
						title="Prohibited Business Verticals"
						showBadge={defaultValue ? !isEqualWith(value, defaultValue, isEqualAsSet) : undefined}
						badgeText="Exceptions"
						badgeTooltip={`This onboarding rules for this Org<br>
									include exceptions to the bank's<br>
									default onboarding rules.`}
						badgeTooltipClassname="risk-settings-badge-tooltip"
						badgeTooltipKey="prohibited-business-verticals-badge-tooltip"
						heading="h1"
					/>
				}
				subtitle={<ProhibitedBusinessVerticalsSubtitle />}
				className="header-with-large-gap"
				icon={<ProhibitedBusinessVerticalsIcon />}
			>
				<BusinessVerticalsField
					name={name}
					label="Select the Business Verticals you wish to prohibit"
					value={value}
					setFieldValue={setFieldValue}
					setFieldTouched={setFieldTouched}
					hideClearAllIndicator
				/>
			</Card>
		</div>
	)
}
